import { useQuery } from '@tanstack/react-query';
import { PatientDetailsType } from '../../../provider/pages/PatientDetail/interfaces/patientDetails';
import http from '../../../utils/http';

export function useGetSinglePatientRecord(patientId: string) {
  const { data, isLoading, refetch, ...rest } = useQuery({
    queryKey: ['get provider patients', patientId || null],
    queryFn: async () => {
      const response = await http.get(`providers/patient?patientId=${patientId}`);
      return response.data;
    },
    enabled: !!patientId,
    // refetch data every 1 minute for real-time updates when the patientId is available
    refetchInterval: patientId ? 3600000 : false,// fetch appointment every 1hour
  });
  return {
    data: data as PatientDetailsType,
    isLoading,
    refetchProviders: refetch,
    ...rest,
  }
}
